import {createRoot} from 'react-dom/client'

import {App} from './App'
import {initializeApp} from './initializeApp'

initializeApp()
  .then(() => {
    const rootElement = document.getElementById('root')
    const root = createRoot(rootElement as HTMLElement)

    root.render(<App />)
  })
  .catch((error) => {
    console.error('Failed to initialize app:', error)
  })
